import moment from "moment";
import React from "react";
import classNames from "classnames";
import { isEmpty } from "lodash";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";

const ClearPaused = ({ name, updatedBy, updatedAt }) => {
  return (
    <div className={styles.tabContainer}>
      <div className={styles.badgeContainer}>
        <div className={styles.campaignName}>{name}</div>
        <div className={classNames(styles.badge, styles.badgeSuccess)}>
          <div>Paused Cleared</div>
        </div>
      </div>
      <InfoBlock
        header="Paused Clearance Details"
        className={styles.changeTracking}
        config={[
          {
            title: "Paused Cleared On",
            size: {
              sm: 6,
              xs: 6,
            },
            value: updatedAt ? moment(updatedAt).format("MMM DD, YYYY, h:mm A") : undefined,
          },
          {
            title: "Cleared By",
            size: {
              sm: 6,
              xs: 6,
            },
            value: !isEmpty(updatedBy) ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <div
                  style={{ fontSize: "1em" }}
                >{`${updatedBy.firstName} ${updatedBy.lastName}`}</div>
                <div style={{ fontSize: "0.8em", color: "#666" }}>
                  {updatedBy.email.toLowerCase()}
                </div>
              </div>
            ) : undefined,
          },
        ]}
      />
    </div>
  );
};

export default ClearPaused;
